import { render } from "./PosReceipt.vue?vue&type=template&id=942f4e8e&scoped=true&ts=true"
import script from "./PosReceipt.vue?vue&type=script&lang=ts"
export * from "./PosReceipt.vue?vue&type=script&lang=ts"

import "./PosReceipt.vue?vue&type=style&index=0&id=942f4e8e&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942f4e8e"]])

export default __exports__